import { Page } from "@/libs/model/common/index";
/**查询赛事名录列表 */
export class DirectoryPageListVO extends Page {
  constructor() {
    super();
    this.name = "";
  }
}
